import {
    addChatEvent,
    updateChatEvent,
    reportError,
    setAgent,
    setAgentTyping,
    setSessionActive,
    setChatState,
    setFileLimits,
    setAPISubmode,
    CHAT_STATE,
    MESSAGE_TYPE,
    //setOffTopic,
    setMonitorForUserMOLogin,
    setInputMask
} from '../components/views/chat/actions';
import { WIDGET_ACTIONS } from '../components/layers/widget/types';
import { APISubmode } from '../api/types';
import Logger from '../../common/logger';
import CustomMessage from '../genesys/customMessage';
import Tracker from './tracker';
import IPC from '../helpers/ipc';
import { MAIN_ACTIONS } from '../components/main/types';
import * as WidgetConditions from '../components/layers/widget/conditions';
import ApplicationContext from '../helpers/applicationcontext';
import { CHAT } from '../../child/components/views/chat/types';
import * as QuestionnareActions from '../components/views/questionnaire/actions';

// 60 sekund braku odpowiedzi jest akceptowalne do zachowania łączności dla komendy "refresh"
const REFRESH_TIMEOUT_ERROR = 60;
const JSONMAGIC = '8434>$9429';

const APIV2 = {
    MESSAGE_TYPE: {
        PARTICIPANT_JOINED: 'ParticipantJoined',
        PARTICIPANT_LEFT: 'ParticipantLeft',
        MESSAGE: 'Message',
        CUSTOMMESSAGE: 'CustomMessage',
        TYPING_STARTED: 'TypingStarted',
        TYPING_STOPPED: 'TypingStopped',
        TRANSFER: 'Transfer',
        NOTICE: 'Notice',
        FILE_UPLOADED: 'FileUploaded'
    },
    NOTICE: {
        FILE_CLIENT_CONFIG_GET: 'file-client-cfg-get'
    },
    FROM_TYPE: {
        AGENT: 'Agent',
        CLIENT: 'Client'
    },
    STATUS_CODE: {
        OK: 0,
        WARN: 1,
        ERROR: 2
    }
};

const STORAGEKEY = {
    CHATSTATE: 'oplwidget.state',
    CHAT: 'oplwidget.chat',
    WINDOWID: 'oplwidget.windowid',
    ERRORCOUNT: 'oplwidget.errorcount'
};

export const encodeMessage = (message) => {
    return JSONMAGIC + JSON.stringify(message);
};

export default class GenesysDriver {
    constructor(store) {
        this.store = store;
        this.API = null;

        this.session = null;
        this.refreshInterval = null;

        this.processMessages = this.processMessages.bind(this);

        this.cleanup = this.cleanup.bind(this);
        this.typingTimeout = null;
        this.messagePreview = null;
        this.errorCount = 0;
        this.firstErrorTime = null;

        this.windowID = this.getRandomInt(100000, 999999).toString();

        this.windowUnloaded = this.windowUnloaded.bind(this);
        window.addEventListener('beforeunload', this.windowUnloaded);
        window.addEventListener('unload', this.windowUnloaded);
    }

    getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    windowUnloaded() {
        if (window.localStorage && localStorage.getItem(STORAGEKEY.WINDOWID) === this.windowID) {
            localStorage.removeItem(STORAGEKEY.WINDOWID);
        }
    }

    isSessionActive() {
        if (!window.localStorage || window.OPLWidgetIgnoreSessionCheck) return false;
        return localStorage.getItem(STORAGEKEY.WINDOWID) !== null;
    }

    isSessionActiveOnThisWindow() {
        if (!window.localStorage || window.OPLWidgetIgnoreSessionCheck) return false;
        const wid = localStorage.getItem(STORAGEKEY.WINDOWID);
        return wid !== null && wid === this.windowID;
    }

    urlEncodeParams(params, parent_property = undefined) {
        const formBody = [];
        for (const property in params) {
            if (Object.prototype.hasOwnProperty.call(params, property)) {
                const encodedKey = parent_property
                    ? encodeURIComponent(parent_property) + '[' + encodeURIComponent(property) + ']'
                    : encodeURIComponent(property);
                const value = params[property];
                if (Array.isArray(value) || value instanceof Object) {
                    const subparams = this.urlEncodeParams(value, property);
                    formBody.push(subparams);
                } else {
                    const encodedValue = encodeURIComponent(value);
                    formBody.push(encodedKey + '=' + encodedValue);
                }
            }
        }
        return formBody.join('&');
    }

    sendRequestN(command, parameters, successCallback) {
        this.sendRequest({
            command,
            parameters,
            session: this.session,
            callbacks: {
                success: successCallback
            }
        });
    }

    sendDownloadRequest({ session, command, callbacks }) {
        if (!this.API) {
            const state = this.store.getState();
            this.API = state.settings.env.serverURL;
        }

        if (!this.session) {
            this.session = session;
        }

        let url = [this.API];
        if (session && session.chatId) {
            url.push(session.chatId);
        }

        if (command) {
            url.push(command);
        }

        url = url.join('/');

        const message = {
            url: url,
            secureKey: session.secureKey,
            alias: session.alias,
            userId: session.userId
        };
        IPC.sendEvent(WIDGET_ACTIONS.CHAT_DOWNLOAD, message); // send message to parent which will handle OPLWidget.OnDownload()

        const mo = ApplicationContext.isMojOrange();
        if (!mo) {
            const container = document.createElement('div');
            container.innerHTML = `<form method="POST" enctype="multipart/form-data" target="_blank" action="${url}"><input name="alias" value="${session.alias}" type="hidden"><input name="secureKey" value="${session.secureKey}" type="hidden"><input name="userId" value="${session.userId}" type="hidden"></form>`;
            const form = container.firstChild;
            document.body.appendChild(form);
            form.submit();
        }

        if (callbacks.success) {
            callbacks.success();
        }
    }

    sendRequest({ session, command, parameters, callbacks, destinationAPI }) {
        if (!this.API) {
            const state = this.store.getState();
            this.API = state.settings.env.serverURL;
        }

        if (!this.session) {
            this.session = session;
        }

        let url = [this.API];
        if (session && session.chatId) {
            url.push(session.chatId);
        }

        if (command) {
            url.push(command);
        }

        let body = { ...parameters };

        // const userDataPropertiesToUpdate = ['userData[web_order_id]'];
        // let updateData = false;
        // userDataPropertiesToUpdate.forEach(p => {
        //     if (parameters[p]) {
        //         updateData = true;
        //     }
        // });

        // if (updateData) {
        //     Logger.log('[APIV2] sendRequest: update user data');
        //     url.push('updateData');
        // }

        url = url.join('/');

        let acceptBinary = false;
        if (parameters && parameters.acceptBinary) {
            acceptBinary = parameters.acceptBinary;
            delete parameters['acceptBinary'];
        }
        if (session) {
            body = {
                ...body,
                userId: session.userId,
                secureKey: session.secureKey,
                alias: session.alias
            };
        }

        Logger.log(
            '[APIV2] sendRequest: ' +
                (command || '/') +
                ' parameters: ' +
                JSON.stringify(parameters)
        );

        fetch(url, {
            method: 'POST',
            headers: {
                Accept: 'application/json;charset=UTF-8',
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: this.urlEncodeParams(body)
        })
            .then((response) => {
                if (acceptBinary) {
                    if (response.status === 200) {
                        return response.blob();
                    }
                    return {
                        statusCode: 0,
                        chatEnded: false,
                        errors: [
                            {
                                code: response.status,
                                advice: 'Załącznik niedostępny'
                            }
                        ],
                        _widgetInternal: true,
                        _source: 'CHAT'
                    };
                } else {
                    const contentType = response.headers.get('Content-Type');
                    if (response.status === 200 && contentType.indexOf('json') >= 0) {
                        return response.text();
                    } else {
                        let statusCode = 2;
                        let code = response.status;
                        let advice = response.statusText;

                        if (contentType.indexOf('json') === -1) {
                            code = 415;
                            advice = `Unsupported Content-Type: ${contentType}`;
                        }

                        if (
                            command === 'refresh' ||
                            command === 'startTyping' ||
                            command === 'stopTyping'
                        ) {
                            statusCode = 1;
                        }
                        return {
                            statusCode,
                            chatEnded: statusCode === 2,
                            errors: [
                                {
                                    code,
                                    advice
                                }
                            ],
                            _widgetInternal: true,
                            _source: 'CHAT'
                        };
                    }
                }
            })
            .then((response) => {
                if (response instanceof Object || response instanceof Blob || acceptBinary) {
                    return response;
                }

                const len = response.length;
                if (len === 0) {
                    return {
                        statusCode: 2,
                        chatEnded: true,
                        errors: [
                            {
                                code: 504,
                                advice: 'Empty response'
                            }
                        ],
                        _widgetInternal: true,
                        _source: 'CHAT'
                    };
                }

                try {
                    response = JSON.parse(response);
                    return response;
                } catch (ex) {
                    return {
                        statusCode: 2,
                        chatEnded: true,
                        errors: [
                            {
                                code: 504,
                                advice: ex.message
                            }
                        ],
                        _widgetInternal: true,
                        _source: 'CHAT'
                    };
                }
            })
            .then((response) => {
                if (acceptBinary) {
                    if (response.errors) {
                        Logger.error(
                            '[APIV2] response: ' +
                                JSON.stringify(response) +
                                ' on command: ' +
                                command
                        );
                    } else {
                        const url = URL.createObjectURL(response);
                        IPC.sendEvent(MAIN_ACTIONS.OPEN_URL, { url: url, blank: true });
                        setTimeout(() => {
                            URL.revokeObjectURL(url);
                        }, 1000);

                        if (callbacks.success) {
                            callbacks.success({ ...response, destinationAPI });
                        }

                        return url;
                    }
                } else {
                    // statusCode = 0 - ok, 1 - error but retry, 2 - error final
                    switch (response.statusCode) {
                        case 0:
                            Logger.log(
                                `[APIV2] response: ${JSON.stringify(
                                    response
                                )} on command: ${command}`
                            );
                            this.errorCount = 0;
                            this.firstErrorTime = null;
                            if (callbacks.success) {
                                callbacks.success({ ...response, destinationAPI });
                            }
                            break;
                        case 1:
                            if (this.errorCount === 0) {
                                this.firstErrorTime = new Date().getTime();
                            }
                            this.errorCount++;
                            if (
                                command === null ||
                                new Date().getTime() - this.firstErrorTime >
                                    1000 * REFRESH_TIMEOUT_ERROR
                            ) {
                                this.store.dispatch(
                                    reportError({
                                        errorCount: this.errorCount,
                                        level: 'error',
                                        command: command,
                                        time: new Date().toLocaleTimeString(),
                                        details: response.errors
                                    })
                                );
                                Logger.error(
                                    `[APIV2] error response: ${JSON.stringify(
                                        response
                                    )} on command: ${command}`
                                );
                                response = {
                                    ...response,
                                    chatEnded: true,
                                    statusCode: 2
                                };
                                if (callbacks.error) {
                                    callbacks.error(response);
                                }
                            } else {
                                this.store.dispatch(
                                    reportError({
                                        errorCount: this.errorCount,
                                        level: 'warn',
                                        command: command,
                                        time: new Date().toLocaleTimeString(),
                                        details: response.errors
                                    })
                                );
                                Logger.warn(
                                    `[APIV2] warn response: ${JSON.stringify(
                                        response
                                    )} on command: ${command} errorCount: ${this.errorCount}`
                                );
                            }
                            break;
                        case 2:
                            // tu dostajemy finalny error odebrany z chat server: resonse: {chatEnded: true, statusCode: 2, errors: [{ advice, code}]}
                            this.store.dispatch(
                                reportError({
                                    errorCount: this.errorCount,
                                    level: 'error',
                                    command: command,
                                    time: new Date().toLocaleTimeString(),
                                    details: response.errors
                                })
                            );
                            Logger.error(
                                `[APIV2] error response: ${JSON.stringify(
                                    response
                                )} on command: ${command}`
                            );
                            if (callbacks.error) {
                                callbacks.error(response);
                            }
                            break;
                        default:
                            break;
                    }
                }
            })
            .catch((error) => {
                if (this.errorCount === 0) {
                    this.firstErrorTime = new Date().getTime();
                }
                this.errorCount++;
                const now = new Date().getTime() - this.firstErrorTime;
                let statusCode = 2;
                if (
                    (command === 'refresh' ||
                        command === 'startTyping' ||
                        command === 'stopTyping') &&
                    now <= 1000 * REFRESH_TIMEOUT_ERROR
                ) {
                    statusCode = 1;
                }
                if (command === 'send') {
                    this.store.dispatch(
                        reportError({
                            errorCount: this.errorCount,
                            level: 'warn',
                            command: command,
                            time: new Date().toLocaleTimeString(),
                            details: error.message
                        })
                    );
                    this.store.dispatch(
                        addChatEvent({
                            message: `Nie udało się wysłać wiadomości: ${body.message}`,
                            timestamp: new Date().valueOf(),
                            localtimestamp: new Date().valueOf(),
                            id: -2,
                            from: 'system',
                            type: MESSAGE_TYPE.MESSAGE
                        })
                    );
                    return;
                }

                if (error instanceof TypeError && statusCode === 2) {
                    this.store.dispatch(
                        reportError({
                            errorCount: this.errorCount,
                            level: 'error',
                            command: command,
                            time: new Date().toLocaleTimeString(),
                            details: error.message
                        })
                    );
                    Logger.error(
                        `[APIV2] error response: ${JSON.stringify(
                            error.message
                        )} on command: ${command} errorCount: ${this.errorCount}`
                    );
                    if (callbacks.error) {
                        callbacks.error({
                            statusCode: statusCode,
                            chatEnded: statusCode === 2,
                            errors: [
                                {
                                    code: 504,
                                    advice: error.message
                                }
                            ],
                            _widgetInternal: true,
                            _source: 'CHAT'
                        });
                    }
                } else {
                    // tu łapiemy timouty na refresh
                    this.store.dispatch(
                        reportError({
                            errorCount: this.errorCount,
                            level: 'warn',
                            command: command,
                            time: new Date().toLocaleTimeString(),
                            details: error.message
                        })
                    );
                    Logger.warn(
                        `[APIV2] warn response: ${JSON.stringify(
                            error.message
                        )} on command: ${command} errorCount: ${this.errorCount}`
                    );
                }
            });
    }

    sendRequestTransfer({ session, callbacks }) {
        if (!session || !session.chatId) {
            Logger.error('[APIv2] sendRequestTransfer: no chatId');
            return;
        }

        if (!this.API) {
            const state = this.store.getState();
            this.API = state.settings.env.serverURL;
        }

        let url = [this.API];
        url.push(session.chatId);
        url.push('updateData');
        url = url.join('/');

        const body = {
            userId: session.userId,
            secureKey: session.secureKey,
            alias: session.alias,
            'userData[categoryType]': 'chat'
        };

        Logger.log('[APIV2] sendRequest: ' + '/' + ' parameters: ' + JSON.stringify(body));
        Logger.log('[APIV2] sendRequest: url=' + url);

        fetch(url, {
            method: 'POST',
            headers: {
                Accept: 'application/json;charset=UTF-8',
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: this.urlEncodeParams(body)
        })
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    return {
                        statusCode: 2,
                        chatEnded: true,
                        errors: [
                            {
                                code: response.status,
                                advice: response.statusText
                            }
                        ],
                        _widgetInternal: true
                    };
                }
            })
            .then((response) => {
                // statusCode = 0 - ok, 1 - error but retry, 2 - error final
                if (response.errors) {
                    Logger.error('[APIV2] response: ' + JSON.stringify(response));
                } else {
                    Logger.log('[APIV2] response: ' + JSON.stringify(response));
                }

                if (callbacks.success) {
                    callbacks.success(response);
                }
            })
            .catch((error) => {
                Logger.error('[APIV2] error: ' + JSON.stringify(error));
                if (callbacks.error) {
                    callbacks.error(error);
                }
            });
    }

    processMessagesN(response) {
        this.processMessages({
            session: this.session,
            response
        });
    }

    processMessages({ session, response, callbacks, processText }) {
        Logger.log('[APIV2] process last response');

        if (!session) {
            return;
        }

        if (response.statusCode !== APIV2.STATUS_CODE.ERROR) {
            session.userId = response.userId || null;
            session.secureKey = response.secureKey || null;
            session.alias = response.alias || null;
            session.chatEnded = response.chatEnded;

            sessionStorage.setItem(STORAGEKEY.CHAT, JSON.stringify(session));
            if (window.localStorage && session.chatEnded) {
                if (localStorage.getItem(STORAGEKEY.WINDOWID) === this.windowID) {
                    localStorage.removeItem(STORAGEKEY.WINDOWID);
                }
            } else if (window.localStorage) {
                localStorage.setItem(STORAGEKEY.WINDOWID, this.windowID);
            }
        }

        if (response.chatEnded && response.statusCode === APIV2.STATUS_CODE.ERROR) {
            callbacks.endSession(false);
            return;
        }

        let agentLeftTime = -1;
        let clientLeftTime = -1;
        let cleanChatEnd = false;
        if (response.messages) {
            response.messages.forEach((message) => {
                if (
                    message.index === undefined &&
                    message.type === APIV2.MESSAGE_TYPE.NOTICE &&
                    message.text === APIV2.NOTICE.FILE_CLIENT_CONFIG_GET
                ) {
                    this.store.dispatch(setFileLimits(message.userData));
                }
                if (message.index >= session.lastPosition) {
                    // save position
                    sessionStorage.setItem(STORAGEKEY.CHAT, JSON.stringify(session));
                    const state = this.store.getState();

                    switch (message.type) {
                        case APIV2.MESSAGE_TYPE.PARTICIPANT_JOINED:
                            if (message.from.type === APIV2.FROM_TYPE.AGENT) {
                                Tracker.sendEvent('widgetChatAgentConnected');
                                this.store.dispatch(setAgent(true, message.from.nickname));
                                this.store.dispatch(
                                    addChatEvent({
                                        message: 'Doradca Orange dołączył do rozmowy.',
                                        username: message.from.nickname,
                                        timestamp: message.utcTime,
                                        localtimestamp: new Date().valueOf(),
                                        id: message.index,
                                        from: 'system',
                                        type: MESSAGE_TYPE.AGENT_JOINED,
                                        max:
                                            state.chat.submode === APISubmode.MAX &&
                                            message.from.nickname.toUpperCase() === 'MAX'
                                    })
                                );
                                if (
                                    state.chat.submode === APISubmode.MAX &&
                                    message.from.nickname.toUpperCase() !== 'MAX'
                                ) {
                                    this.store.dispatch(setAPISubmode(null));
                                }
                            } else {
                                this.store.dispatch(setSessionActive(true));
                            }
                            break;
                        case APIV2.MESSAGE_TYPE.PARTICIPANT_LEFT:
                            if (message.from.type !== APIV2.FROM_TYPE.CLIENT) {
                                Tracker.sendEvent('widgetChatAgentDisconnected');

                                if (response.chatEnded) {
                                    const buildEndingMessage = (state) => {
                                        let message = '';
                                        if (QuestionnareActions.areConditionsMet('api')) {
                                            message +=
                                                'Twoja opinia jest dla nas ważna\n[Wypełnij proszę ankietę](view:questionnaire)\n\n';
                                        }
                                        if (WidgetConditions.isChatSaveAvailable(state).available) {
                                            message +=
                                                'Chcesz zapisać rozmowę?\n[Zapisz](view:save)';
                                        }
                                        return message;
                                    };
                                    const endingMessage = buildEndingMessage(this.store.getState());
                                    if (endingMessage.length > 0) {
                                        this.store.dispatch(
                                            addChatEvent({
                                                message: endingMessage,
                                                username: message.from.nickname,
                                                timestamp: message.utcTime,
                                                localtimestamp: new Date().valueOf(),
                                                id: message.index,
                                                from: 'agent',
                                                type: MESSAGE_TYPE.MESSAGE,
                                                messageType: message.messageType,
                                                customMessage: null,
                                                max:
                                                    state.chat.submode === APISubmode.MAX &&
                                                    message.from.nickname.toUpperCase() === 'MAX'
                                            })
                                        );
                                    }
                                }

                                agentLeftTime = message.utcTime;
                                this.store.dispatch(setAgent(false, ''));
                                this.store.dispatch(setAgentTyping(false));
                                message.from.type === APIV2.FROM_TYPE.AGENT &&
                                    this.store.dispatch(
                                        addChatEvent({
                                            message: 'Doradca Orange opuścił rozmowę.',
                                            timestamp: message.utcTime,
                                            localtimestamp: new Date().valueOf(),
                                            id: message.index + 1000,
                                            from: 'system',
                                            type: MESSAGE_TYPE.AGENT_LEFT,
                                            max:
                                                state.chat.submode === APISubmode.MAX &&
                                                message.from.nickname.toUpperCase() === 'MAX'
                                        })
                                    );
                                cleanChatEnd = true;
                            } else {
                                clientLeftTime = message.utcTime;
                                this.store.dispatch(setSessionActive(false));
                                cleanChatEnd = response.chatEnded;
                            }
                            break;
                        case APIV2.MESSAGE_TYPE.MESSAGE:
                            if (message.text && processText) {
                                let contentType = MESSAGE_TYPE.MESSAGE;
                                let messageNickname = message.from.nickname;
                                let messageText = message.text;
                                let messageType = message.messageType || 'text';
                                let customMessage = null;

                                // * type – typ wiadomości (message, sendEvent) [pole wymagane]
                                // * message – zawartość tekstowa wiadomości (formatowanie zgodnie z pkt. 1) [pole opcjonalne]
                                // * detail – dodatkowa wiadomość wyświetlana tylko u doradcy [pole opcjonalne]
                                // * from – nadawca (agent, client, bot) [pole wymagane]
                                // * payload – obiekt zawierający dodatkowe dane [pole opcjonalne]

                                // * Testing "formatText"
                                //
                                // const messageToEncode = {
                                //     type: 'message',
                                //     message: messageText,
                                //     from: 'agent',
                                //     payload: {
                                //         command: 'formatText',
                                //         options: {
                                //             format: 'formLink',
                                //             textToFormat: 'Dzień dobry',
                                //             value: 'QE_OCS_CHAT_WIDGET_STATIC'
                                //         }
                                //     }
                                // };
                                // const encodedMessage =
                                //     JSONMAGIC + JSON.stringify(messageToEncode);
                                // messageText = encodedMessage;

                                // * Testing "setQuestionnaireName"
                                //
                                // if (
                                //     messageText.indexOf('Jestem Max') > -1 ||
                                //     messageText.indexOf('pomóc') > -1
                                // ) {
                                //     const messageToEncode = {
                                //         type: 'message',
                                //         message: messageText,
                                //         from: 'agent',
                                //         payload: {
                                //             command: 'setQuestionnaireName',
                                //             parameter: 'QE_CHAT_WIDGET_MNP'
                                //         }
                                //     };
                                //     const encodedMessage =
                                //         JSONMAGIC + JSON.stringify(messageToEncode);
                                //     messageText = encodedMessage;
                                // }

                                // // * Testing "showButtons"

                                // if (
                                //     // messageText.indexOf('Jestem Max') > -1 ||
                                //     messageText.indexOf('pomóc') > -1 ||
                                //     messageText.indexOf('pewien') > -1
                                // ) {
                                //     const messageToEncode = {
                                //         type: 'message',
                                //         source: 'agent',
                                //         payload: {
                                //             command: 'showOptions',
                                //             groupOptionsByCount: 2,
                                //             options: [
                                //                 {
                                //                     text: 'Przycisk 1',
                                //                     id: 'id1'
                                //                 },
                                //                 {
                                //                     text: 'Przycisk 2',
                                //                     id: 'id2'
                                //                 },
                                //                 {
                                //                     text: 'Przycisk 3',
                                //                     id: 'id3'
                                //                 },
                                //                 {
                                //                     text: 'Przycisk 4',
                                //                     id: 'id4'
                                //                 },
                                //                 {
                                //                     text: 'Przycisk 5',
                                //                     id: 'id5'
                                //                 },
                                //                 {
                                //                     text: 'Przycisk 6',
                                //                     id: 'id6'
                                //                 },
                                //                 {
                                //                     text: 'Przycisk 7',
                                //                     id: 'id7'
                                //                 },
                                //                 {
                                //                     text: 'Przycisk 8',
                                //                     id: 'id8'
                                //                 },
                                //                 {
                                //                     text: 'Przycisk 9',
                                //                     id: 'id9'
                                //                 }
                                //             ]
                                //         }
                                //     };
                                //     const encodedMessage =
                                //         JSONMAGIC + JSON.stringify(messageToEncode);
                                //     messageText = encodedMessage;
                                // }

                                // // * Testing "showDeviceConfig"

                                // if (
                                //     messageText.indexOf('Jestem Max') > -1 ||
                                //     messageText.indexOf('pomóc') > -1
                                // ) {
                                //     const messageToEncode =
                                //         messageText.indexOf('Jestem Max') > -1
                                //             ? {
                                //                 type: 'message',
                                //                 message:
                                //                     messageText +
                                //                     ' Kliknij w [link](view:deviceConfig), żeby poznać szczegóły konfiguracji dla **iPhone X**.',
                                //                 payload: {
                                //                     command: 'showDeviceConfig',
                                //                     options: {
                                //                         title: 'iPhone X',
                                //                         html:
                                //                             '<p><ol><li>Naciśnij <strong>USTAWIENIA</strong>.</li><li>Wybierz <strong>DANE SIECI KOM</strong>.</li><li>Upewnij się że opcja <strong>DANE SIECI KOM.</strong> jest włączona.</li><li>Przejdź do <strong>USTAWIENIA APN</strong>.</li><li>W pole <strong>APN</strong> i wpisz <strong><b>internet </b></strong> </li><li>W pole <strong>UŻYTKOWNIK</strong> i wpisz <strong><b>internet </b></strong> </li><li>W pole <strong>HASŁO</strong> i wpisz <strong><b>internet </b></strong> </li><li>Wróć do głównego menu używając przycisku <strong>HOME</strong>.</li><li>Aby przeglądać strony <strong><b>Orange World </b></strong>, uruchom przeglądarkę <strong>SAFARI</strong>, wpisz w pasku adresu <strong>http://www.orange.pl</strong> i wybierz <strong>IDŹ</strong>.</li></ol></p>'
                                //                     }
                                //                 }
                                //             }
                                //             : {
                                //                 type: 'message',
                                //                 message:
                                //                     messageText +
                                //                     ' Kliknij w [link](view:deviceConfig), żeby poznać szczegóły konfiguracji dla **iPad**.',
                                //                 payload: {
                                //                     command: 'showDeviceConfig',
                                //                     options: {
                                //                         title: 'iPad',
                                //                         html:
                                //                             '<p><ol><li>Naciśnij <strong>USTAWIENIA</strong>.</li><li>Wybierz <strong>DANE SIECI KOM</strong>.</li><li>Upewnij się że opcja <strong>DANE SIECI KOM.</strong> jest włączona.</li><li>Przejdź do <strong>USTAWIENIA APN</strong>.</li><li>W pole <strong>APN</strong> i wpisz <strong><b>internet </b></strong> </li><li>W pole <strong>UŻYTKOWNIK</strong> i wpisz <strong><b>internet </b></strong> </li><li>W pole <strong>HASŁO</strong> i wpisz <strong><b>internet </b></strong> </li><li>Wróć do głównego menu używając przycisku <strong>HOME</strong>.</li><li>Aby przeglądać strony <strong><b>Orange World </b></strong>, uruchom przeglądarkę <strong>SAFARI</strong>, wpisz w pasku adresu <strong>http://www.orange.pl</strong> i wybierz <strong>IDŹ</strong>.</li></ol></p>'
                                //                     }
                                //                 }
                                //             };
                                //     const encodedMessage =
                                //         JSONMAGIC + JSON.stringify(messageToEncode);
                                //     messageText = encodedMessage;
                                // }

                                // // * Testing "showAddressForm"
                                // if (
                                //     // messageText.indexOf('Jestem Max') > -1 ||
                                //     messageText.indexOf('pomóc') > -1 ||
                                //     messageText.indexOf('pewien') > -1
                                // ) {
                                //     const messageToEncode = {
                                //         type: 'message',
                                //         source: 'agent',
                                //         payload: {
                                //             command: 'showAddressForm'
                                //         }
                                //     };
                                //     const encodedMessage =
                                //         JSONMAGIC + JSON.stringify(messageToEncode);
                                //     messageText = encodedMessage;
                                // }

                                //--Clear input mode
                                if (messageText && state.chat.inputMask) {
                                    setInputMask('');
                                }

                                if (messageType === 'json' || messageText.startsWith(JSONMAGIC)) {
                                    try {
                                        customMessage =
                                            messageType === 'json'
                                                ? JSON.parse(messageText)
                                                : JSON.parse(
                                                      messageText.substring(JSONMAGIC.length)
                                                  );
                                        switch (customMessage.type) {
                                            case 'message':
                                                customMessage =
                                                    CustomMessage.process(customMessage);
                                                messageText = customMessage.message;
                                                messageNickname = customMessage.username
                                                    ? customMessage.username
                                                    : messageNickname;
                                                break;

                                            case 'sendEvent':
                                                contentType = MESSAGE_TYPE.CUSTOMMESSAGE;
                                                messageText = null;
                                                if (customMessage.payload) {
                                                    Tracker.sendEvent(
                                                        customMessage.payload.event,
                                                        customMessage.payload.data
                                                    );
                                                }
                                                break;

                                            default:
                                                messageText = null;
                                                break;
                                        }
                                        messageType = 'json';
                                    } catch ($ex) {
                                        messageText = null;
                                    }
                                }

                                if (messageText) {
                                    if (
                                        messageText.match(/orange.pl\/zaloguj.phtml/) ||
                                        messageText.match(/orange.pl\/twojekonto\/zaloguj/) ||
                                        messageText.match(/orange.pl\/moj-orange\/logout/)
                                    ) {
                                        if (
                                            (state.chat.submode &&
                                                state.chat.submode === APISubmode.MAX) ||
                                            state.chat.agent.name === CHAT.WIRTUALNY_KONSULTANT
                                        ) {
                                            setMonitorForUserMOLogin(true);
                                            Tracker.sendEvent('widgetMonitorForUserMOLogin');
                                        }
                                    }
                                    this.store.dispatch(
                                        addChatEvent({
                                            message: messageText,
                                            username: messageNickname,
                                            timestamp: message.utcTime,
                                            localtimestamp: new Date().valueOf(),
                                            id: message.index,
                                            from:
                                                message.from.type === APIV2.FROM_TYPE.AGENT
                                                    ? 'agent'
                                                    : message.from.type === APIV2.FROM_TYPE.CLIENT
                                                    ? 'client'
                                                    : 'system',
                                            type:
                                                customMessage && customMessage.contentType
                                                    ? customMessage.contentType
                                                    : contentType,
                                            messageType: messageType,
                                            customMessage: customMessage,
                                            max:
                                                state.chat.submode === APISubmode.MAX &&
                                                message.from.nickname.toUpperCase() === 'MAX'
                                        })
                                    );
                                }

                                this.store.dispatch(setAgentTyping(false));
                            }
                            break;
                        case APIV2.MESSAGE_TYPE.TYPING_STARTED:
                            if (message.from.type === APIV2.FROM_TYPE.AGENT) {
                                this.store.dispatch(setAgentTyping(true));
                            }
                            break;
                        case APIV2.MESSAGE_TYPE.TYPING_STOPPED:
                            if (
                                message.from.type !== APIV2.FROM_TYPE.AGENT &&
                                callbacks.clearTyping
                            ) {
                                callbacks.clearTyping();
                            } else if (message.from.type === APIV2.FROM_TYPE.AGENT) {
                                this.store.dispatch(setAgentTyping(false));
                            }
                            break;
                        case APIV2.MESSAGE_TYPE.FILE_UPLOADED:
                            if (!(message.text && processText)) {
                                break;
                            }
                            if (message.errors === undefined || message.errors.length === 0) {
                                this.store.dispatch(
                                    addChatEvent({
                                        message: message.userData['file-name'],
                                        username: message.from.nickname,
                                        timestamp: message.utcTime,
                                        localtimestamp: new Date().valueOf(),
                                        id: message.index,
                                        from:
                                            message.from.type === APIV2.FROM_TYPE.AGENT
                                                ? 'agent'
                                                : message.from.type === APIV2.FROM_TYPE.CLIENT
                                                ? 'client'
                                                : 'system',
                                        type: MESSAGE_TYPE.FILE_UPLOADED,
                                        messageType: 'text',
                                        customMessage: message.userData
                                    })
                                );
                            }
                            this.store.dispatch(setAgentTyping(false));
                            if (callbacks.fileUploaded) {
                                callbacks.fileUploaded();
                            }
                            break;
                        default:
                            break;
                    }
                }
            }, this);
        }
        if (agentLeftTime !== -1 && agentLeftTime !== clientLeftTime) {
            this.store.dispatch(
                addChatEvent({
                    message: 'Rozmowa została przekierowana do innego doradcy.',
                    timestamp: agentLeftTime,
                    localtimestamp: new Date().valueOf(),
                    id: -2,
                    from: 'system',
                    type: MESSAGE_TYPE.TRANSFER
                })
            );
        }

        if (response.chatEnded) {
            callbacks.endSession(cleanChatEnd);
        }
    }

    cleanup() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
            this.refreshInterval = null;
        }
        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
            this.typingTimeout = null;
        }
    }

    // TODO disabled until BOT refactoring
    // startChat(userData = null) {
    //     const initTimer = () => {
    //         if (this.session && !this.session.chatEnded) {
    //             if (!this.refreshInterval) {
    //                 this.refreshInterval = setInterval(this.refresh, REFRESH_TIMER * 1000);
    //             }
    //             window.addEventListener('unload', this.cleanup, false);
    //         }
    //     };

    //     if(window.localStorage) {
    //         const session = sessionStorage.getItem(STORAGEKEY.CHAT);
    //         if (session) {
    //             Logger.log('[APIv2] Session restored');
    //             // restore chat session
    //             this.session = JSON.parse(session);
    //             // reinit refresh timer
    //             initTimer();
    //             return;
    //         }
    //         else {
    //             const wid = localStorage.getItem(STORAGEKEY.WINDOWID);
    //             if(wid !== null && wid !== this.windowID) {
    //                 Logger.info('[APIv2] Chat already running on another window');
    //                 this.processEndOfSession(false, 'Sesja czat jest już aktywna w innym oknie');
    //                 return;
    //             }
    //         }
    //         localStorage.setItem(STORAGEKEY.WINDOWID, this.windowID);
    //     }

    //     const state = this.store.getState();
    //     if (state.chat.state !== CHAT_STATE.NOT_STARTED) {
    //         // chat already finished, don't restart with new session.
    //         // User must close chat window (will change state to CHAT_STATE.NOT_STARTED) and open new one.
    //         return;
    //     }

    //     // start new session, set required parameter nickname
    //     const parameters = {
    //         nickname: userData ? (userData.FirstName || 'User').trim() : 'User'
    //     };

    //     // add userData kvp
    //     if (userData) {
    //         for (const key in userData) {
    //             if (userData[key]) {
    //                 parameters[`userData[${key}]`] = String(userData[key]).trim();
    //             }
    //         }
    //     }

    //     Logger.log('[APIv2] Start new session');
    //     this.sendRequest(null, parameters, (response) => {
    //         Logger.log('[APIv2] Session started');
    //         this.session = {
    //             chatEnded: false,
    //             chatId: response.chatId,
    //             lastPosition: 0
    //         };
    //         initTimer();
    //         this.store.dispatch(setChatState(CHAT_STATE.RUNNING));
    //         this.processMessages(response);

    //         Tracker.acceptChatInvite();
    //     });
    // }

    processEndOfSession(cleanChatEnd, failMessage = 'Sesja rozmowy czat wygasła.') {
        this.clearTyping();

        this.store.dispatch(setChatState(CHAT_STATE.FINISHED));

        const state = this.store.getState();
        if (state.chat.sessionActive) {
            this.store.dispatch(setSessionActive(false));
        }
        const messages = state.chat.messages.filter((m) => m.chatEnded);
        if (messages.length === 0 || !cleanChatEnd) {
            this.store.dispatch(
                addChatEvent({
                    message: cleanChatEnd ? 'Rozmowa została zakończona.' : failMessage,
                    timestamp: new Date().valueOf(),
                    localtimestamp: new Date().valueOf(),
                    id: -1,
                    from: 'system',
                    chatEnded: true,
                    type: MESSAGE_TYPE.SESSION_END,
                    failure: !cleanChatEnd
                })
            );
        }
        this.cleanup();
        sessionStorage.removeItem(STORAGEKEY.CHAT);
        if (window.localStorage && localStorage.getItem(STORAGEKEY.WINDOWID) === this.windowID) {
            localStorage.removeItem(STORAGEKEY.WINDOWID);
        }
        this.session = null;
    }

    // TODO disabled until BOT refactoring
    // closeChat() {
    //     const state = this.store.getState();
    //     if (state.chat.state === CHAT_STATE.RUNNING) {
    //         this.sendRequest('disconnect', null, () => {
    //             // this.processMessages(response);
    //             this.processEndOfSession(true);
    //         });
    //     }
    // }

    // TODO disabled until BOT refactoring
    // sendMessage(message) {
    //     this.clearTyping();
    //     this.messagePreview = null;

    //     this.sendRequest('send', {
    //         message: message,
    //         messageType: 'text'
    //     }, (response) => {
    //         this.processMessages(response);
    //         this.refresh();
    //     });
    // }

    // TODO disabled until BOT refactoring
    // refresh(messagePreview = this.messagePreview) {
    //     // this.store.dispatch(addChatEvent({
    //     //     message: 'debug, debug',
    //     //     nickname: 'Zofia',
    //     //     id: -1,
    //     //     from: 'agent',
    //     //     type: MESSAGE_TYPE.MESSAGE
    //     // }));

    //     const params = {
    //         transcriptPosition: this.session.lastPosition === 0 ? 1 : this.session.lastPosition
    //     };
    //     // don't send when no message is set
    //     if (messagePreview !== undefined && messagePreview !== null) {
    //         params['message'] = messagePreview;
    //     }
    //     this.sendRequest('refresh', params, (response) => {
    //         this.processMessages(response);
    //         if(this.session)
    //             this.session.lastPosition = response.nextPosition;
    //         // save position
    //         sessionStorage.setItem(STORAGEKEY.CHAT, JSON.stringify(this.session));
    //     });
    // }

    sendTyping({ messagePreview, callbacks }) {
        const resetTimeout = () => {
            this.typingTimeout = setTimeout(() => {
                this.typingTimeout = null;
                callbacks.stopTyping();
            }, 9500);
        };

        if (this.typingTimeout) {
            // already typing
            this.messagePreview = messagePreview;
            clearTimeout(this.typingTimeout);
            resetTimeout();
            return;
        }

        if (messagePreview && !this.typingTimeout) {
            const params = {};
            params['message'] = messagePreview;
            callbacks.startTyping(params);
            this.messagePreview = messagePreview;

            resetTimeout();
        }
    }

    clearTyping() {
        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
            this.typingTimeout = null;
        }
        // this.messagePreview = null;
    }

    // Chat Session File Management

    getLimits() {
        this.sendRequestN('file/limits', null, (response) => {
            this.processMessagesN(response);
        });
    }

    /**
     * Upload file with File object
     *
     * @param {File} file object to upload
     */
    uploadFile(file) {
        const state = this.store.getState();
        let url = [state.settings.env.storageURL, '3600'];
        url = url.join('/');

        const form = new FormData();
        form.append('attachment', file);

        var xhr = new XMLHttpRequest();
        this.xhr = xhr;

        const identifier = this.getRandomInt(99999, 99999999);

        this.xhr.upload.onprogress = (e) => {
            if (e.lengthComputable) {
                var percentage = Math.round((e.loaded * 100) / e.total);
                Logger.log(
                    `[Storage] Sending file: ${file.name} [${percentage}%, id=${identifier}]`
                );
                this.store.dispatch(
                    updateChatEvent({
                        id: -1,
                        progress: percentage
                    })
                );
            }
        };

        xhr.upload.onload = () => {
            Logger.log(`[Storage] Response: ${this.response}`);
            if (this.status === 200) {
                // success
                Logger.log(`[Storage] Finished sending file: ${file.name} [id=${identifier}]`);
            } else {
                // error
                Logger.warn(`[Storage] Error sending file: ${file.name} [id=${identifier}]`);
            }
        };
        xhr.open('POST', url, true);
        xhr.send(form);

        Logger.log(`[Storage] Send file: ${file.name} [id=${identifier}]`);
    }

    /**
     * Download file from Genesys
     *
     * @param {string} identifier
     */
    downloadFile(identifier) {
        const url = ['file', identifier, 'download'];
        this.sendRequestN(url.join('/'), null, (response) => {
            this.processMessagesN(response);
        });
    }
}
